/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Quick_Start_Tabs_LabelInputs */

const en_mcp_quick_start_tabs_label = /** @type {(inputs: Mcp_Quick_Start_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your agent`)
};

const es_mcp_quick_start_tabs_label = /** @type {(inputs: Mcp_Quick_Start_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige tu agente`)
};

/**
* | output |
* | --- |
* | "Choose your agent" |
*
* @param {Mcp_Quick_Start_Tabs_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_quick_start_tabs_label = /** @type {((inputs?: Mcp_Quick_Start_Tabs_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Quick_Start_Tabs_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_quick_start_tabs_label(inputs)
	return en_mcp_quick_start_tabs_label(inputs)
});